<template>
  <div class="d-flex justify-end head-wrapper">
    <v-app-bar
      app
      color="white"
      elevate-on-scroll
      ref="header"
      :height="headerBarHeight"
    >
      <my-container class="d-flex align-center  fill-height">
        <v-toolbar-title class=" fill-height">
          <router-link to="/">
            <picture class="logo img-responsive">
              <img
                class="logo img-responsive fill-height"
                src="@/assets/img/_src/FMSH.svg"
                :alt="title"
              />
            </picture>
            <main-text class="ml-2 d-none d-md-inline">{{ title }}</main-text>
            <main-text class="ml-2 d-inline d-md-none">{{
              shortTitle
            }}</main-text>
          </router-link>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <slot></slot>
      </my-container>
    </v-app-bar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import MyContainer from "@/components/MyContainer";
import MainText from "@/components/MainText";

export default {
  name: "Header",
  components: { MainText, MyContainer },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["title", "shortTitle", "headerBarHeight"])
  }
};
</script>

<style lang="scss">
header.mx-auto {
  padding: 0;
}

.v-toolbar__title a {
  color: black !important;
}

.head-wrapper {
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: auto;
  z-index: 7;

  .v-app-bar {
    position: relative !important;

    &.v-toolbar--collapsed {
      border-bottom-left-radius: 24px !important;
      border-bottom-right-radius: 0 !important;
    }
  }
}
</style>
